module.exports = __webpack_public_path__ + "static/img/b2-1-1.294a37a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/b2-1-1.png
// module id = snjM
// module chunks = 1